import { Modifier, EditorState } from 'draft-js';
import getReplacementText from '../utils/getReplacementText';
import getTypeByTrigger from '../utils/getTypeByTrigger';

const addMention = (
  editorState,
  mention,
  mentionPrefix,
  mentionTrigger,
  entityMutability,
  whitespaceAfterMention,
  onlyAddText
) => {
  let entityKey = null;
  // TODO: If trigger is `{` character, we will insert text and not create mention entity
  // To allow filter when clear mention text by press on Backspace
  // Prevent clear entire mention text when press on Backspace
  if (!onlyAddText) {
    const contentStateWithEntity = editorState
      .getCurrentContent()
      .createEntity(getTypeByTrigger(mentionTrigger), entityMutability, {
        mention,
      });
    entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  }

  const currentSelectionState = editorState.getSelection();
  // TODO: getReplacementText for both cases: add new mention and change current mention
  const { begin, end } = getReplacementText(editorState, currentSelectionState, mentionTrigger);

  // get selection of the @mention search text
  const mentionTextSelection = currentSelectionState.merge({
    anchorOffset: begin,
    focusOffset: end,
  });

  let mentionReplacedContent = Modifier.replaceText(
    editorState.getCurrentContent(),
    mentionTextSelection,
    `${mentionPrefix}${mention.name}`,
    null, // no inline style needed
    entityKey
  );

  // If the mention is inserted at the end, a space is appended right after for
  // a smooth writing experience.
  const blockKey = mentionTextSelection.getAnchorKey();
  const blockSize = editorState.getCurrentContent().getBlockForKey(blockKey).getLength();
  if (blockSize === end) {
    mentionReplacedContent = Modifier.insertText(
      mentionReplacedContent,
      mentionReplacedContent.getSelectionAfter(),
      whitespaceAfterMention ? ' ' : ''
    );
  }

  const newEditorState = EditorState.push(editorState, mentionReplacedContent, 'insert-mention');
  return EditorState.forceSelection(newEditorState, mentionReplacedContent.getSelectionAfter());
};

export default addMention;
